import React, { useState, useEffect, useCallback } from 'react';import axios from './config/axiosConfig';


import './Dashboard.css';

function AdminDashboard({ selectedMonth, selectedYear, onGoBack, clienteInfo }) {
    const [listaLancamentos, setListaLancamentos] = useState([]);
    const [lancamentosIA, setLancamentosIA] = useState([]); // Novo estado para lançamentos da IA
    const [groupedLancamentos, setGroupedLancamentos] = useState({});
    const [filteredGroupedLancamentos, setFilteredGroupedLancamentos] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [fornecedores, setFornecedores] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [lancamentosSelecionados, setLancamentosSelecionados] = useState([]);
    const [reportSelecionados, setReportSelecionados] = useState([]); // Seleções no relatório
    const [contasCorrentes, setContasCorrentes] = useState([]); // Lista de contas de crédito da Omie
    const [editingLancamento, setEditingLancamento] = useState(null);
    const [editingIAId, setEditingIAId] = useState(null); // Novo estado para edição de IA
    const [showEditForm, setShowEditForm] = useState(false);
    const [searchEditFornecedor, setSearchEditFornecedor] = useState('');
    const [searchEditCategoria, setSearchEditCategoria] = useState('');
    const [showEditFornecedorDropdown, setShowEditFornecedorDropdown] = useState(false);
    const [showEditCategoriaDropdown, setShowEditCategoriaDropdown] = useState(false);

    const [showReport, setShowReport] = useState(false);
    const [selectedAccountData, setSelectedAccountData] = useState(null);
    const [launchingToOmie, setLaunchingToOmie] = useState(false);

    const [showCreateForm, setShowCreateForm] = useState(false);
    const [newLancamento, setNewLancamento] = useState({
        fornecedor: '',
        categoria: '',
        contaCorrente: '',
        dataCompra: '',
        dataVencimento: '',
        valorCompra: '',
        observacao: ''
    });
    const [searchCreateFornecedor, setSearchCreateFornecedor] = useState('');
    const [searchCreateCategoria, setSearchCreateCategoria] = useState('');
    const [showCreateFornecedorDropdown, setShowCreateFornecedorDropdown] = useState(false);
    const [showCreateCategoriaDropdown, setShowCreateCategoriaDropdown] = useState(false);
    const [searchNewFornecedor, setSearchNewFornecedor] = useState('');
    const [searchNewCategoria, setSearchNewCategoria] = useState('');
    const [showNewFornecedorDropdown, setShowNewFornecedorDropdown] = useState(false);
    const [showNewCategoriaDropdown, setShowNewCategoriaDropdown] = useState(false);

    const [filters, setFilters] = useState({
        fornecedor: '',
        categoria: '',
        contaCorrente: '',
        dataInicio: '',
        dataFim: ''
    });
    const [showFilters, setShowFilters] = useState(false);

    const monthNames = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    const monthName = selectedMonth ? monthNames[selectedMonth - 1] : '';

    const formatCurrency = (value) => {
        if (!value) return 'R$ 0,00';
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    };

    const formatDateBR = (dateString) => {
        if (!dateString) return '';

        // Se a data vier no formato ISO completo (com hora), extrair apenas a parte da data
        const dateOnly = dateString.split('T')[0];

        const [year, month, day] = dateOnly.split('-');
        return `${day}/${month}/${year}`;
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';

        // Se a data vier no formato ISO completo (com hora), extrair apenas a parte da data
        const dateOnly = dateString.split('T')[0];

        // Retorna no formato YYYY-MM-DD para o input type="date"
        return dateOnly;
    };

    const formatDateForOmie = (dateString) => {
    if (!dateString) return '';

    // 1. Limpa a string de data (remove a parte T e Z)
    const dateOnly = dateString.split('T')[0]; // Pega YYYY-MM-DD

    // 2. Extrai e reordena as partes
    const parts = dateOnly.split('-');

    if (parts.length === 3) {
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];

        // Formato final OMIE: DD/MM/AAAA (10 caracteres)
        return `${day}/${month}/${year}`;
    }

    // Se não for um formato válido, retorna a string original ou vazio
    return '';
};

    const formatDateInput = (dateString) => {
        if (!dateString) return '';
        // Se já está no formato YYYY-MM-DD, retorna
        if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return dateString;
        }
        // Remove a parte de hora se existir (YYYY-MM-DDTHH:MM:SS)
        const dateOnly = dateString.split('T')[0];
        return dateOnly;
    };

    const applyFilters = useCallback(() => {
        const filteredGroups = {};
        Object.entries(groupedLancamentos).forEach(([conta, lancamentos]) => {
            // Filtrar por conta corrente primeiro
            if (filters.contaCorrente && conta !== filters.contaCorrente) {
                return; // Pula esta conta se não corresponder ao filtro
            }

            let filtered = [...lancamentos];
            if (filters.fornecedor) {
                filtered = filtered.filter(item =>
                    item.fornecedor && item.fornecedor.toLowerCase().includes(filters.fornecedor.toLowerCase())
                );
            }
            if (filters.categoria) {
                filtered = filtered.filter(item =>
                    item.categoria && item.categoria.toLowerCase().includes(filters.categoria.toLowerCase())
                );
            }
            if (filters.dataInicio) {
                filtered = filtered.filter(item => {
                    if (!item.dataCompra) return false;
                    const itemDate = new Date(item.dataCompra);
                    const startDate = new Date(filters.dataInicio);
                    return itemDate >= startDate;
                });
            }
            if (filters.dataFim) {
                filtered = filtered.filter(item => {
                    if (!item.dataCompra) return false;
                    const itemDate = new Date(item.dataCompra);
                    const endDate = new Date(filters.dataFim);
                    return itemDate <= endDate;
                });
            }
            if (filtered.length > 0) {
                filteredGroups[conta] = filtered;
            }
        });
        setFilteredGroupedLancamentos(filteredGroups);
    }, [groupedLancamentos, filters]);

    useEffect(() => {
        applyFilters();
    }, [applyFilters]);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('token');
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const [lancamentosResponse, lancamentosIAResponse] = await Promise.all([
                axios.get(
                    `/api/admin/lancamentos?mes=${selectedMonth}&ano=${selectedYear}&clienteId=${clienteInfo.id}`,
                    config
                ),
                axios.get(
                    `/api/admin/lancamentos/ia?mes=${selectedMonth}&ano=${selectedYear}&clienteId=${clienteInfo.id}`,
                    config
                )
            ]);

            setListaLancamentos(lancamentosResponse.data);
            setLancamentosIA(lancamentosIAResponse.data);
            const grouped = lancamentosResponse.data.reduce((acc, current) => {
                const conta = current.contaCorrente || 'Outras';
                if (!acc[conta]) {
                    acc[conta] = [];
                }
                acc[conta].push(current);
                return acc;
            }, {});
            setGroupedLancamentos(grouped);
        } catch (err) {
            setError('Não foi possível carregar os lançamentos. Verifique a conexão com o back-end.');
            console.error('Erro ao buscar dados:', err.response?.data?.error || err.message);
        } finally {
            setLoading(false);
        }
    }, [selectedMonth, selectedYear, clienteInfo.id]);

    const fetchOmieData = useCallback(async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('[AdminDashboard] Token não encontrado');
            return;
        }

        if (!clienteInfo || !clienteInfo.id) {
            console.error('[AdminDashboard] ClienteInfo inválido:', clienteInfo);
            return;
        }

        console.log('[AdminDashboard] Buscando dados da Omie para cliente:', clienteInfo.id);

        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        // Adicionando a chamada para contas correntes
        const [fornecedoresRes, categoriasRes, contasCorrentesRes] = await Promise.all([
            axios.post('/api/admin/omie/fornecedores',
                { clienteId: clienteInfo.id },
                config
            ).catch(err => {
                console.error('[AdminDashboard] Erro ao buscar fornecedores:', err.response?.data || err.message);
                return { data: [] };
            }),
            axios.post('/api/admin/omie/categorias',
                { clienteId: clienteInfo.id },
                config
            ).catch(err => {
                console.error('[AdminDashboard] Erro ao buscar categorias:', err.response?.data || err.message);
                return { data: [] };
            }),
            axios.post('/api/admin/omie/contas-correntes',
                { clienteId: clienteInfo.id },
                config
            ).catch(err => {
                console.error('[AdminDashboard] Erro ao buscar contas correntes:', err.response?.data || err.message);
                return { data: [] };
            })
        ]);

        console.log('[AdminDashboard] Fornecedores recebidos:', fornecedoresRes.data?.length || 0);
        console.log('[AdminDashboard] Categorias recebidas:', categoriasRes.data?.length || 0);
        console.log('[AdminDashboard] Contas correntes recebidas:', contasCorrentesRes.data?.length || 0);

        setFornecedores(fornecedoresRes.data || []);
        const categoriasValidas = (categoriasRes.data || []).filter(c =>
            c.descricao && !c.descricao.toLowerCase().includes('disponível')
        );
        setCategorias(categoriasValidas);

        // SALVA AS CONTAS CORRENTES
        setContasCorrentes(contasCorrentesRes.data || []);
    } catch (err) {
        console.error('[AdminDashboard] Erro geral ao buscar dados da Omie:', err);
        // É importante NÃO setar o erro aqui, ou ele sobreescreverá o erro de carregamento de lançamentos.
    }
}, [clienteInfo]);

    useEffect(() => {
        if (selectedMonth && selectedYear && clienteInfo) {
            fetchData();
            fetchOmieData();
        }
    }, [fetchData, fetchOmieData, selectedMonth, selectedYear, clienteInfo]);

    const clearFilters = () => {
        setFilters({
            fornecedor: '',
            categoria: '',
            contaCorrente: '',
            dataInicio: '',
            dataFim: ''
        });
    };

    const getActiveFiltersCount = () => {
        return Object.values(filters).filter(value => value.trim() !== '').length;
    };

    const calculateGeneralTotals = () => {
        const allFilteredLancamentos = Object.values(filteredGroupedLancamentos).flat();
        
        const totalMensal = allFilteredLancamentos.reduce((acc, item) => {
            // Alteração 1: Usar valorParcela se for parcelado
            const isParcelado = parseInt(item.quantidadeParcelas) > 0;
            const valor = isParcelado 
                ? parseFloat(item.valorParcela) || 0
                : parseFloat(item.valorCompra) || 0;
            return acc + valor;
        }, 0);

        return {
            total: totalMensal,
            count: allFilteredLancamentos.length,
            accounts: Object.keys(filteredGroupedLancamentos).length
        };
    };

     const calculateAccountTotals = (lancamentos) => {
        const totalMensal = lancamentos.reduce((acc, item) => {
            // Alteração 2: Usar valorParcela se for parcelado
            const isParcelado = parseInt(item.quantidadeParcelas) > 0;
            const valor = isParcelado 
                ? parseFloat(item.valorParcela) || 0
                : parseFloat(item.valorCompra) || 0;
            return acc + valor;
        }, 0);

        return { total: totalMensal, count: lancamentos.length };
    };

    const totals = calculateGeneralTotals();

    const filteredEditFornecedores = fornecedores.filter(f =>
        f.razao_social && f.razao_social.toLowerCase().includes(searchEditFornecedor.toLowerCase())
    );

    const filteredEditCategorias = categorias.filter(c =>
        c.descricao && c.descricao.toLowerCase().includes(searchEditCategoria.toLowerCase())
    );

    const filteredCreateFornecedores = fornecedores.filter(f =>
        f.razao_social && f.razao_social.toLowerCase().includes(searchCreateFornecedor.toLowerCase())
    );

    const filteredCreateCategorias = categorias.filter(c =>
        c.descricao && c.descricao.toLowerCase().includes(searchCreateCategoria.toLowerCase())
    );

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleGenerateReport = (conta) => {
        const data = filteredGroupedLancamentos[conta];
        // Filtrar lançamentos que não estão marcados para ignorar
        const lancamentosVisiveis = data.filter(l => !l.ignorarOmie);
        setSelectedAccountData({
            conta,
            lancamentos: lancamentosVisiveis,
            totalLancamentos: data.length,
            lancamentosIgnorados: data.length - lancamentosVisiveis.length
        });
        setReportSelecionados([]); // Limpar seleções ao abrir relatório
        setShowReport(true);
    };

    const handleEditLancamento = (lancamentoToEdit) => {
        setEditingLancamento({
            ...lancamentoToEdit,
            dataCompra: formatDateInput(lancamentoToEdit.dataCompra),
            dataVencimento: formatDateInput(lancamentoToEdit.dataVencimento)
        });
        setSearchEditFornecedor(lancamentoToEdit.fornecedor || '');
        setSearchEditCategoria(lancamentoToEdit.categoria || '');
        setShowEditForm(true);
        setShowReport(false);
    };

    const handleUpdateChange = (e) => {
        const { name, value } = e.target;
        setEditingLancamento(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectEditFornecedor = (fornecedor) => {
        setEditingLancamento(prev => ({
            ...prev,
            fornecedor: fornecedor.razao_social,
            codigo_cliente_fornecedor: fornecedor.codigo_cliente_omie
        }));
        setSearchEditFornecedor(fornecedor.razao_social);
        setShowEditFornecedorDropdown(false);
    };

    const handleSelectEditCategoria = (categoria) => {
        setEditingLancamento(prev => ({
            ...prev,
            categoria: categoria.descricao,
            cod_categoria: categoria.codigo
        }));
        setSearchEditCategoria(categoria.descricao);
        setShowEditCategoriaDropdown(false);
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const dataToUpdate = {
                fornecedor: editingLancamento.fornecedor,
                categoria: editingLancamento.categoria,
                contaCorrente: editingLancamento.contaCorrente,
                dataCompra: editingLancamento.dataCompra,
                dataVencimento: editingLancamento.dataVencimento || editingLancamento.dataCompra,
                valorCompra: parseFloat(editingLancamento.valorCompra),
                observacao: editingLancamento.observacao || ''
            };
                
            await axios.put(`/api/admin/lancamentos/${editingLancamento.id}`, 
                dataToUpdate, 
                config
            );

            alert('Lançamento atualizado com sucesso!');
            setShowEditForm(false);
            setEditingLancamento(null);
            fetchData();
        } catch (error) {
            console.error('Erro ao atualizar o lançamento:', error.response?.data?.error || error.message);
            alert('Erro ao atualizar o lançamento.');
        }
    };

    const handleCreateChange = (e) => {
        const { name, value } = e.target;
        setNewLancamento(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectCreateFornecedor = (fornecedor) => {
        setNewLancamento(prev => ({
            ...prev,
            fornecedor: fornecedor.razao_social,
            codigo_cliente_fornecedor: fornecedor.codigo_cliente_omie
        }));
        setSearchCreateFornecedor(fornecedor.razao_social);
        setShowCreateFornecedorDropdown(false);
    };

    const handleSelectCreateCategoria = (categoria) => {
        setNewLancamento(prev => ({
            ...prev,
            categoria: categoria.descricao,
            cod_categoria: categoria.codigo
        }));
        setSearchCreateCategoria(categoria.descricao);
        setShowCreateCategoriaDropdown(false);
    };

    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const dataToCreate = {
                fornecedor: newLancamento.fornecedor,
                categoria: newLancamento.categoria,
                contaCorrente: newLancamento.contaCorrente,
                dataCompra: newLancamento.dataCompra,
                dataVencimento: newLancamento.dataVencimento || newLancamento.dataCompra,
                valorCompra: parseFloat(newLancamento.valorCompra),
                observacao: newLancamento.observacao || '',
                clienteId: clienteInfo.id,
                mes: selectedMonth,
                ano: selectedYear
            };

            await axios.post('/api/admin/lancamentos',
                dataToCreate,
                config
            );

            alert('Lançamento criado com sucesso!');
            setShowCreateForm(false);
            setNewLancamento({
                fornecedor: '',
                categoria: '',
                contaCorrente: '',
                dataCompra: '',
                dataVencimento: '',
                valorCompra: '',
                observacao: ''
            });
            setSearchCreateFornecedor('');
            setSearchCreateCategoria('');
            fetchData();
        } catch (error) {
            console.error('Erro ao criar o lançamento:', error.response?.data?.error || error.message);
            alert('Erro ao criar o lançamento.');
        }
    };
    
    const handleDeleteLancamento = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir este lançamento?')) {
            try {
                const token = localStorage.getItem('token');
                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };

                await axios.delete(`/api/admin/lancamentos/${id}`, config);
                alert('Lançamento excluído com sucesso!');
                fetchData();
            } catch (error) {
                console.error('Erro ao excluir o lançamento:', error);
                alert('Erro ao excluir o lançamento.');
            }
        }
    };
    
    const handleBulkDelete = async () => {
        if (lancamentosSelecionados.length === 0) {
            alert('Selecione pelo menos um lançamento para excluir.');
            return;
        }

        if (window.confirm(`Tem certeza que deseja excluir ${lancamentosSelecionados.length} lançamentos?`)) {
            try {
                const token = localStorage.getItem('token');
                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };

                // Deletar um por um já que não temos endpoint de bulk delete para admin
                for (const id of lancamentosSelecionados) {
                    await axios.delete(`/api/admin/lancamentos/${id}`, config);
                }
                
                alert(`${lancamentosSelecionados.length} lançamentos excluídos com sucesso!`);
                setLancamentosSelecionados([]);
                fetchData();
            } catch (error) {
                console.error('Erro ao excluir lançamentos em massa:', error);
                alert('Erro ao excluir lançamentos. Tente novamente.');
            }
        }
    };

    // Funções para criação de novo lançamento
    const filteredNewFornecedores = fornecedores.filter(f =>
        f.razao_social && f.razao_social.toLowerCase().includes(searchNewFornecedor.toLowerCase())
    );

    const filteredNewCategorias = categorias.filter(c =>
        c.descricao && c.descricao.toLowerCase().includes(searchNewCategoria.toLowerCase())
    );

    const handleNewLancamentoChange = (e) => {
        const { name, value } = e.target;
        setNewLancamento(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectNewFornecedor = (fornecedor) => {
        setNewLancamento(prev => ({
            ...prev,
            fornecedor: fornecedor.razao_social,
            codigo_cliente_fornecedor: fornecedor.codigo_cliente_omie
        }));
        setSearchNewFornecedor(fornecedor.razao_social);
        setShowNewFornecedorDropdown(false);
    };

    const handleSelectNewCategoria = (categoria) => {
        setNewLancamento(prev => ({
            ...prev,
            categoria: categoria.descricao,
            cod_categoria: categoria.codigo
        }));
        setSearchNewCategoria(categoria.descricao);
        setShowNewCategoriaDropdown(false);
    };

    const handleSelectLancamento = (id) => {
        setLancamentosSelecionados(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const handleSelectAll = (lancamentos) => {
        // Se todos já estão selecionados, desmarca todos
        const visibleIds = lancamentos.slice(0, 5).map(item => item.id);
        const allSelected = visibleIds.every(id => lancamentosSelecionados.includes(id));

        if (allSelected) {
            // Desmarcar todos os visíveis
            setLancamentosSelecionados(prev => prev.filter(id => !visibleIds.includes(id)));
        } else {
            // Marcar todos os visíveis
            setLancamentosSelecionados(prev => {
                const newSelected = [...prev];
                visibleIds.forEach(id => {
                    if (!newSelected.includes(id)) {
                        newSelected.push(id);
                    }
                });
                return newSelected;
            });
        }
    };

    // Funções para seleção no relatório
    const handleSelectReportLancamento = (id) => {
        setReportSelecionados(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const handleSelectAllReport = (lancamentos) => {
        const allIds = lancamentos.map(item => item.id);
        const allSelected = allIds.every(id => reportSelecionados.includes(id));

        if (allSelected) {
            // Desmarcar todos
            setReportSelecionados([]);
        } else {
            // Marcar todos
            setReportSelecionados(allIds);
        }
    };

    // Funções para manipular lançamentos da IA
    const handleValidarIA = async (id) => {
        if (window.confirm('Deseja validar este lançamento? Ele será movido para os lançamentos confirmados.')) {
            try {
                const token = localStorage.getItem('token');
                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };

                await axios.put(`/api/admin/lancamentos/${id}/validar`, {}, config);
                setLancamentosIA(lancamentosIA.filter(item => item.id !== id));
                fetchData();
                alert('Lançamento validado com sucesso!');
            } catch (error) {
                console.error('Erro ao validar lançamento:', error.response?.data?.error || error.message);
                alert('Erro ao validar lançamento. Tente novamente.');
            }
        }
    };

    const handleEditIA = (item) => {
        setEditingIAId(item.id);
        setEditingLancamento({ ...item });
        setSearchEditFornecedor(item.fornecedor || '');
        setSearchEditCategoria(item.categoria || '');
        setShowEditForm(true);
        setShowReport(false);
    };

    const handleDeleteIA = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir este lançamento sugerido pela IA?')) {
            try {
                const token = localStorage.getItem('token');
                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };

                await axios.delete(`/api/admin/lancamentos/${id}`, config);
                setLancamentosIA(lancamentosIA.filter(item => item.id !== id));
                alert('Lançamento da IA excluído com sucesso!');
            } catch (error) {
                console.error('Erro ao excluir lançamento:', error.response?.data?.error || error.message);
                alert('Erro ao excluir lançamento.');
            }
        }
    };

    // Função para marcar/desmarcar lançamento como ignorar na Omie
    const handleIgnorarOmie = async (id, ignorarAtual) => {
        const novoEstado = !ignorarAtual;
        try {
            const token = localStorage.getItem('token');
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            await axios.put(`/api/admin/lancamentos/${id}/ignorar`,
                { ignorar: novoEstado },
                config
            );

            // Atualizar o estado local
            const updateGroupedLancamentos = () => {
                const updated = {};
                Object.entries(groupedLancamentos).forEach(([conta, lancamentos]) => {
                    updated[conta] = lancamentos.map(l =>
                        l.id === id ? { ...l, ignorarOmie: novoEstado } : l
                    );
                });
                return updated;
            };

            setGroupedLancamentos(updateGroupedLancamentos());
            setListaLancamentos(listaLancamentos.map(l =>
                l.id === id ? { ...l, ignorarOmie: novoEstado } : l
            ));

        } catch (error) {
            console.error('Erro ao marcar/desmarcar ignorar:', error.response?.data?.error || error.message);
            alert('Erro ao marcar/desmarcar lançamento. Tente novamente.');
        }
    };

    const handleLaunchToOmie = async () => {
    if (!selectedAccountData) return;

    // Filtrar apenas lançamentos que não estão marcados para ignorar
    const lancamentosParaEnviar = selectedAccountData.lancamentos.filter(l => !l.ignorarOmie);

    if (lancamentosParaEnviar.length === 0) {
        alert('Nenhum lançamento válido para enviar. Todos estão marcados como ignorar.');
        return;
    }

    const confirmMessage = `Tem certeza que deseja lançar ${lancamentosParaEnviar.length} registros da conta "${selectedAccountData.conta}" na Omie?\n(${selectedAccountData.lancamentos.length - lancamentosParaEnviar.length} registro(s) serão ignorados)`;
    if (!window.confirm(confirmMessage)) return;

    setLaunchingToOmie(true);
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        // Buscar o código da conta corrente
        const contaOmie = contasCorrentes.find(c => c.descricao === selectedAccountData.conta);
        if (!contaOmie) {
            throw new Error(`Conta "${selectedAccountData.conta}" não encontrada na Omie`);
        }

        const lancamentosPreparados = [];
        const erros = [];

        for (const lanc of lancamentosParaEnviar) {
            // Buscar fornecedor
            const fornecedorOmie = fornecedores.find(f => 
                f.razao_social === lanc.fornecedor
            );
            
            if (!fornecedorOmie) {
                erros.push(`Fornecedor "${lanc.fornecedor}" não encontrado`);
                continue;
            }

            // Buscar categoria
            const categoriaOmie = categorias.find(c => 
                c.descricao === lanc.categoria
            );
            
            if (!categoriaOmie) {
                erros.push(`Categoria "${lanc.categoria}" não encontrada`);
                continue;
            }
            
            // 🎯 CORREÇÃO CRÍTICA AQUI 🎯
            // Usa valorParcela se existir (para lançar a parcela mensal)
            const valorDocumento = parseFloat(lanc.valorParcela) || parseFloat(lanc.valorCompra); 

                    lancamentosPreparados.push({
                    codigo_lancamento_integracao: `ADMIN_${lanc.id}_${Date.now()}`,
                    codigo_cliente_fornecedor: fornecedorOmie.codigo_cliente_omie,
                    id_conta_corrente: contaOmie.codigo,
                    
                    // 🟢 CORREÇÃO DA DATA: Usa a nova formatDateForOmie()
                    data_vencimento: formatDateForOmie(lanc.dataVencimento || lanc.dataCompra),
                    data_emissao: formatDateForOmie(lanc.dataCompra), 
                    
                    // 🟢 CORREÇÃO DA PROPRIEDADE: Agora usa a variável corrigida acima
                    valor_documento: valorDocumento,
                    codigo_categoria: categoriaOmie.codigo,
                    observacao: lanc.observacao || '',
                    numero_documento: lanc.numeroDocumento || ''
                });
            }
        if (erros.length > 0) {
            const continuar = window.confirm(
                `Foram encontrados ${erros.length} erros:\n${erros.slice(0, 5).join('\n')}\n\nDeseja continuar com os ${lancamentosPreparados.length} lançamentos válidos?`
            );
            if (!continuar) {
                setLaunchingToOmie(false);
                return;
            }
        }

        if (lancamentosPreparados.length === 0) {
            throw new Error('Nenhum lançamento válido para enviar');
        }

        await axios.post('/api/admin/omie/lancamentos-lote', 
            {
                lancamentos: lancamentosPreparados,
                clienteId: clienteInfo.id
            },
            config
        );
        
        alert(`✅ Sucesso! ${lancamentosPreparados.length} lançamentos enviados para a Omie.`);
        setShowReport(false);
        setSelectedAccountData(null);
    } catch (error) {
        console.error('Erro ao lançar para Omie:', error);
        const errorMessage = error.response?.data?.error || error.message || 'Erro desconhecido';
        alert(`❌ Erro ao lançar para Omie:\n\n${errorMessage}`);
    } finally {
        setLaunchingToOmie(false);
    }
};
    
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.dropdown-container')) {
                setShowEditFornecedorDropdown(false);
                setShowEditCategoriaDropdown(false);
                setShowCreateFornecedorDropdown(false);
                setShowCreateCategoriaDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <main className="main-container">
            <div className="dashboard-title-bar">
                <button onClick={onGoBack} className="back-button">
                    ← Voltar
                </button>
                <div className="title-and-totals">
                    <h2>Lançamentos de {monthName}/{selectedYear} - {clienteInfo.nome} (Admin)</h2>
                    <div className="totals-summary">
                        <span className="total-item">Total: {formatCurrency(totals.total)}</span>
                        <span className="total-item">Registros: {totals.count}</span>
                        <span className="total-item">Contas: {totals.accounts}</span>
                    </div>
                </div>
            </div>

            <div className="action-bar">
                <div className="action-group">
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            setShowFilters(!showFilters);
                            setShowReport(false);
                            setShowEditForm(false);
                            setShowCreateForm(false);
                        }}
                    >
                        <span className="btn-icon">🔍</span>
                        <span className="btn-text">Filtros</span>
                        {getActiveFiltersCount() > 0 && (
                            <span className="filter-badge">{getActiveFiltersCount()}</span>
                        )}
                    </button>
                    <button
                        className="btn btn-success"
                        onClick={() => {
                            setShowCreateForm(!showCreateForm);
                            setShowFilters(false);
                            setShowReport(false);
                            setShowEditForm(false);
                            setNewLancamento({
                                fornecedor: '',
                                categoria: '',
                                contaCorrente: '',
                                dataCompra: '',
                                dataVencimento: '',
                                valorCompra: '',
                                observacao: ''
                            });
                            setSearchNewFornecedor('');
                            setSearchNewCategoria('');
                        }}
                    >
                        <span className="btn-icon">➕</span>
                        <span className="btn-text">Novo Lançamento</span>
                    </button>
                </div>

                {/* Botões que aparecem apenas quando há seleções */}
                {lancamentosSelecionados.length > 0 && (
                    <div className="action-group">
                        <button
                            className="btn btn-warning"
                            onClick={async () => {
                                try {
                                    // Alternar ignorar para todos os selecionados
                                    const allLancamentos = Object.values(groupedLancamentos).flat();
                                    const selectedLancamentos = allLancamentos.filter(l => lancamentosSelecionados.includes(l.id));

                                    // Verificar se algum não está ignorado para definir ação
                                    const hasNaoIgnorado = selectedLancamentos.some(l => !l.ignorarOmie);
                                    const novoEstado = hasNaoIgnorado; // true = ignorar, false = não ignorar

                                    const token = localStorage.getItem('token');
                                    const config = {
                                        headers: { Authorization: `Bearer ${token}` }
                                    };

                                    // Processar todos em paralelo
                                    await Promise.all(
                                        selectedLancamentos.map(lanc =>
                                            axios.put(`/api/admin/lancamentos/${lanc.id}/ignorar`,
                                                { ignorar: novoEstado },
                                                config
                                            )
                                        )
                                    );

                                    // Recarregar todos os dados
                                    await fetchData();

                                    // Limpar seleções após ação
                                    setLancamentosSelecionados([]);

                                    alert(`${selectedLancamentos.length} lançamento(s) ${novoEstado ? 'marcado(s) para ignorar' : 'desmarcado(s)'} com sucesso!`);
                                } catch (error) {
                                    console.error('Erro ao processar lançamentos:', error);
                                    alert('Erro ao processar lançamentos. Tente novamente.');
                                }
                            }}
                        >
                            <span className="btn-icon">👁️</span>
                            <span className="btn-text-mobile">Ignorar ({lancamentosSelecionados.length})</span>
                        </button>
                        {lancamentosSelecionados.length === 1 && (
                            <button
                                className="btn btn-secondary"
                                onClick={() => {
                                    const selectedId = lancamentosSelecionados[0];
                                    const lancamento = Object.values(groupedLancamentos)
                                        .flat()
                                        .find(l => l.id === selectedId);
                                    if (lancamento) {
                                        handleEditLancamento(lancamento);
                                    }
                                }}
                            >
                                <span className="btn-icon">✏️</span>
                                <span className="btn-text-mobile">Editar</span>
                            </button>
                        )}
                        <button className="btn btn-danger" onClick={handleBulkDelete}>
                            <span className="btn-icon">🗑️</span>
                            <span className="btn-text-mobile">Excluir ({lancamentosSelecionados.length})</span>
                        </button>
                    </div>
                )}
            </div>

            {error && (
                <div className="alert alert-error">
                    <span>⚠️ {error}</span>
                </div>
            )}

            {showFilters && (
                <div className="filter-panel">
                    <div className="filter-header">
                        <h3>Filtrar Lançamentos</h3>
                        <button
                            className="close-btn"
                            onClick={() => setShowFilters(false)}
                        >
                            ✕
                        </button>
                    </div>
                    <div className="filter-grid">
                        <div className="filter-group">
                            <label>Fornecedor</label>
                            <select
                                name="fornecedor"
                                value={filters.fornecedor}
                                onChange={handleFilterChange}
                            >
                                <option value="">Todos os fornecedores</option>
                                {fornecedores.map(f => (
                                    <option key={f.codigo_cliente_omie || f.codigo_cliente_fornecedor} value={f.razao_social}>
                                        {f.razao_social}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="filter-group">
                            <label>Categoria</label>
                            <select
                                name="categoria"
                                value={filters.categoria}
                                onChange={handleFilterChange}
                            >
                                <option value="">Todas as categorias</option>
                                {categorias.map(c => (
                                    <option key={c.codigo} value={c.descricao}>
                                        {c.descricao}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="filter-group">
                            <label>Conta Corrente</label>
                            <select
                                name="contaCorrente"
                                value={filters.contaCorrente}
                                onChange={handleFilterChange}
                            >
                                <option value="">Todas as contas</option>
                                {contasCorrentes.map(conta => (
                                    <option key={conta.codigo} value={conta.descricao}>
                                        {conta.descricao}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="filter-group">
                            <label>Data Início</label>
                            <input
                                type="date"
                                name="dataInicio"
                                value={filters.dataInicio}
                                onChange={handleFilterChange}
                            />
                        </div>
                        <div className="filter-group">
                            <label>Data Fim</label>
                            <input
                                type="date"
                                name="dataFim"
                                value={filters.dataFim}
                                onChange={handleFilterChange}
                            />
                        </div>
                        <div className="filter-actions">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={clearFilters}
                            >
                                Limpar Filtros
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showCreateForm && (
                <div className="form-card">
                    <div className="form-header">
                        <h2>Novo Lançamento</h2>
                        <button className="close-btn" onClick={() => {
                            setShowCreateForm(false);
                            setNewLancamento({
                                fornecedor: '',
                                categoria: '',
                                contaCorrente: '',
                                dataCompra: '',
                                dataVencimento: '',
                                valorCompra: '',
                                observacao: ''
                            });
                            setSearchNewFornecedor('');
                            setSearchNewCategoria('');
                        }}>
                            ✕
                        </button>
                    </div>
                    <form onSubmit={handleCreateSubmit} className="form-body">
                        <div className="form-grid">
                            <div className="form-group dropdown-container">
                                <label>Fornecedor *</label>
                                <input
                                    type="text"
                                    value={searchNewFornecedor}
                                    onChange={(e) => {
                                        setSearchNewFornecedor(e.target.value);
                                        setShowNewFornecedorDropdown(true);
                                        setNewLancamento(prev => ({ ...prev, fornecedor: e.target.value }));
                                    }}
                                    onFocus={() => setShowNewFornecedorDropdown(true)}
                                    placeholder="Digite para buscar fornecedor..."
                                    required
                                    autoComplete="off"
                                />
                                {showNewFornecedorDropdown && filteredNewFornecedores.length > 0 && (
                                    <div className="dropdown-list">
                                        {filteredNewFornecedores.slice(0, 30).map(f => (
                                            <div
                                                key={f.codigo_cliente_omie}
                                                className="dropdown-item"
                                                onClick={() => handleSelectNewFornecedor(f)}
                                            >
                                                {f.razao_social}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="form-group dropdown-container">
                                <label>Categoria *</label>
                                <input
                                    type="text"
                                    value={searchNewCategoria}
                                    onChange={(e) => {
                                        setSearchNewCategoria(e.target.value);
                                        setShowNewCategoriaDropdown(true);
                                        setNewLancamento(prev => ({ ...prev, categoria: e.target.value }));
                                    }}
                                    onFocus={() => setShowNewCategoriaDropdown(true)}
                                    placeholder="Digite para buscar categoria..."
                                    required
                                    autoComplete="off"
                                />
                                {showNewCategoriaDropdown && filteredNewCategorias.length > 0 && (
                                    <div className="dropdown-list">
                                        {filteredNewCategorias.slice(0, 30).map(c => (
                                            <div
                                                key={c.codigo}
                                                className="dropdown-item"
                                                onClick={() => handleSelectNewCategoria(c)}
                                            >
                                                {c.descricao}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <label>Conta Corrente *</label>
                                <select
                                    name="contaCorrente"
                                    value={newLancamento.contaCorrente}
                                    onChange={handleNewLancamentoChange}
                                    required
                                >
                                    <option value="">Selecione...</option>
                                    {contasCorrentes.map(conta => (
                                        <option key={conta.codigo} value={conta.descricao}>
                                            {conta.descricao}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Data da Compra *</label>
                                <input
                                    type="date"
                                    name="dataCompra"
                                    value={newLancamento.dataCompra}
                                    onChange={handleNewLancamentoChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Data de Vencimento</label>
                                <input
                                    type="date"
                                    name="dataVencimento"
                                    value={newLancamento.dataVencimento}
                                    onChange={handleNewLancamentoChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Valor da Compra *</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    name="valorCompra"
                                    value={newLancamento.valorCompra}
                                    onChange={handleNewLancamentoChange}
                                    placeholder="0.00"
                                    required
                                />
                            </div>
                            <div className="form-group form-group-full">
                                <label>Observação</label>
                                <textarea
                                    name="observacao"
                                    value={newLancamento.observacao}
                                    onChange={handleNewLancamentoChange}
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>
                        <div className="form-actions">
                            <button type="button" className="btn btn-cancel" onClick={() => {
                                setShowCreateForm(false);
                                setNewLancamento({
                                    fornecedor: '',
                                    categoria: '',
                                    contaCorrente: '',
                                    dataCompra: '',
                                    dataVencimento: '',
                                    valorCompra: '',
                                    observacao: ''
                                });
                                setSearchNewFornecedor('');
                                setSearchNewCategoria('');
                            }}>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-save">
                                Criar Lançamento
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {showEditForm && editingLancamento && (
                <div className="form-card">
                    <div className="form-header">
                        <h2>Editar Lançamento</h2>
                        <button className="close-btn" onClick={() => {
                            setShowEditForm(false);
                            setEditingLancamento(null);
                        }}>
                            ✕
                        </button>
                    </div>
                    <form onSubmit={handleUpdateSubmit} className="form-body">
                        <div className="form-grid">
                            <div className="form-group dropdown-container">
                                <label>Fornecedor *</label>
                                <input
                                    type="text"
                                    value={searchEditFornecedor}
                                    onChange={(e) => {
                                        setSearchEditFornecedor(e.target.value);
                                        setShowEditFornecedorDropdown(true);
                                        setEditingLancamento(prev => ({ ...prev, fornecedor: e.target.value }));
                                    }}
                                    onFocus={() => setShowEditFornecedorDropdown(true)}
                                    placeholder="Digite para buscar fornecedor..."
                                    required
                                    autoComplete="off"
                                />
                                {showEditFornecedorDropdown && filteredEditFornecedores.length > 0 && (
                                    <div className="dropdown-list">
                                        {filteredEditFornecedores.slice(0, 20).map(f => (
                                            <div
                                                key={f.codigo_cliente_omie}
                                                className="dropdown-item"
                                                onClick={() => handleSelectEditFornecedor(f)}
                                            >
                                                {f.razao_social}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="form-group dropdown-container">
                                <label>Categoria *</label>
                                <input
                                    type="text"
                                    value={searchEditCategoria}
                                    onChange={(e) => {
                                        setSearchEditCategoria(e.target.value);
                                        setShowEditCategoriaDropdown(true);
                                        setEditingLancamento(prev => ({ ...prev, categoria: e.target.value }));
                                    }}
                                    onFocus={() => setShowEditCategoriaDropdown(true)}
                                    placeholder="Digite para buscar categoria..."
                                    required
                                    autoComplete="off"
                                />
                                {showEditCategoriaDropdown && filteredEditCategorias.length > 0 && (
                                    <div className="dropdown-list">
                                        {filteredEditCategorias.map(c => (
                                            <div
                                                key={c.codigo}
                                                className="dropdown-item"
                                                onClick={() => handleSelectEditCategoria(c)}
                                            >
                                                {c.descricao}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <label>Conta Corrente *</label>
                                <select 
                                    name="contaCorrente" 
                                    value={editingLancamento.contaCorrente} 
                                    onChange={handleUpdateChange} 
                                    required
                                >
                                    <option value="">Selecione...</option>
                                    {contasCorrentes.map(conta => (
                                        <option key={conta.codigo} value={conta.descricao}>
                                            {conta.descricao}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Data da Compra *</label>
                                <input 
                                    type="date" 
                                    name="dataCompra" 
                                    value={editingLancamento.dataCompra} 
                                    onChange={handleUpdateChange} 
                                    required 
                                />
                            </div>
                            <div className="form-group">
                                <label>Data de Vencimento</label>
                                <input 
                                    type="date" 
                                    name="dataVencimento" 
                                    value={editingLancamento.dataVencimento || ''} 
                                    onChange={handleUpdateChange} 
                                />
                            </div>
                            <div className="form-group">
                                <label>Valor da Compra *</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    name="valorCompra"
                                    value={editingLancamento.valorCompra}
                                    onChange={handleUpdateChange}
                                    placeholder="0.00"
                                    required
                                />
                            </div>
                            <div className="form-group form-group-full">
                                <label>Observação</label>
                                <textarea 
                                    name="observacao" 
                                    value={editingLancamento.observacao || ''} 
                                    onChange={handleUpdateChange} 
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>
                        <div className="form-actions">
                            <button type="button" className="btn btn-cancel" onClick={() => {
                                setShowEditForm(false);
                                setEditingLancamento(null);
                            }}>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-save">
                                Salvar Alterações
                            </button>
                        </div>
                    </form>
                </div>
            )}
            
            {!showFilters && !showReport && !showEditForm && !showCreateForm && (
                <>
                    {loading && (
                        <div className="loading-state">
                            <div className="spinner"></div>
                            <p>Carregando dados...</p>
                        </div>
                    )}
                    
                    {!loading && Object.keys(filteredGroupedLancamentos).length === 0 && (
                        <div className="empty-state">
                            <div className="empty-icon">📊</div>
                            <h3>
                                {Object.keys(groupedLancamentos).length === 0
                                    ? `Nenhum lançamento registrado para ${clienteInfo.nome} em ${monthName}/${selectedYear}`
                                    : "Nenhum lançamento encontrado com os filtros aplicados"
                                }
                            </h3>
                            <p>
                                {Object.keys(groupedLancamentos).length === 0
                                    ? `Nenhum lançamento foi encontrado para este cliente no período selecionado.`
                                    : "Tente ajustar os filtros para encontrar os lançamentos desejados"
                                }
                            </p>
                            {Object.keys(groupedLancamentos).length > 0 && (
                                <button
                                    className="btn btn-secondary"
                                    onClick={clearFilters}
                                    style={{ marginTop: '1rem' }}
                                >
                                    Limpar Filtros
                                </button>
                            )}
                        </div>
                    )}

                    {!loading && Object.keys(filteredGroupedLancamentos).length > 0 && (
                        <>
                            {Object.entries(filteredGroupedLancamentos).map(([conta, lancamentos]) => {
                                const accountTotals = calculateAccountTotals(lancamentos);

                                return (
                                    <div key={conta} className="table-card" style={{ marginBottom: '2rem' }}>
                                        <div className="table-header">
                                            <div className="account-info">
                                                <h2>Conta Corrente: {conta}</h2>
                                                <div className="account-totals">
                                                    <span className="total-item">Total: {formatCurrency(accountTotals.total)}</span>
                                                    <span className="total-item">Registros: {accountTotals.count}</span>
                                                </div>
                                            </div>
                                            <div className="action-group">
                                                <button 
                                                    className="btn btn-primary" 
                                                    onClick={() => handleGenerateReport(conta)}
                                                >
                                                    <span className="btn-icon">📊</span>
                                                    <span className="btn-text-mobile">Gerar Relatório</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="table-wrapper">
                                            <table className="admin-lancamentos-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                checked={lancamentos.slice(0, 5).length > 0 && lancamentos.slice(0, 5).every(item => lancamentosSelecionados.includes(item.id))}
                                                                onChange={() => handleSelectAll(lancamentos)}
                                                                title="Selecionar todas"
                                                            />
                                                        </th>
                                                        <th>Fornecedor</th>
                                                        <th>Categoria</th>
                                                        <th>Valor</th>
                                                        <th>Data Compra</th>
                                                        <th>Vencimento</th>
                                                        <th>Observação</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {lancamentos.slice(0, 5).map(item => (
                                                        <tr key={item.id} className={item.ignorarOmie ? 'lancamento-ignorado' : ''}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={lancamentosSelecionados.includes(item.id)}
                                                                    onChange={() => handleSelectLancamento(item.id)}
                                                                />
                                                            </td>
                                                            <td>{item.fornecedor}</td>
                                                            <td>{item.categoria}</td>
                                                            <td >{item.quantidadeParcelas > 0 ? formatCurrency(item.valorParcela) : formatCurrency(item.valorCompra)}</td>
                                                            <td>{formatDateBR(item.dataCompra)}</td>
                                                            <td>{formatDateBR(item.dataVencimento)}</td>
                                                            <td >{item.observacao || '-'}</td>
                                                        </tr>
                                                    ))}
                                                    {lancamentos.length > 5 && (
                                                        <tr>
                                                            <td colSpan="7" className="text-center" style={{ padding: '16px', fontStyle: 'italic', opacity: '0.7' }}>
                                                                ... e mais {lancamentos.length - 5} lançamentos. Clique em "Gerar Relatório" para ver todos.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </>
            )}

            {showReport && selectedAccountData && (
                <div className="report-card">
                    <div className="report-header">
                        <h2>Relatório de Lançamentos - {selectedAccountData.conta}</h2>
                        <div className="report-actions">
                            <button
                                className="btn btn-secondary"
                                onClick={() => {
                                    setShowReport(false);
                                    setReportSelecionados([]);
                                }}
                            >
                                <span className="btn-icon">←</span>
                                Voltar
                            </button>
                            <button
                                className={`btn btn-save ${launchingToOmie ? 'disabled' : ''}`}
                                onClick={handleLaunchToOmie}
                                disabled={launchingToOmie}
                            >
                                {launchingToOmie ? (
                                    <>
                                        <span className="spinner-small"></span>
                                        Enviando para Omie...
                                    </>
                                ) : (
                                    <>
                                        <span className="btn-icon">🚀</span>
                                        Lançar na Omie
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                    
                    <div className="report-summary">
                        <div className="summary-item">
                            <strong>Total Geral:</strong> {formatCurrency(calculateAccountTotals(selectedAccountData.lancamentos).total)}
                        </div>
                        <div className="summary-item">
                            <strong>Quantidade:</strong> {selectedAccountData.lancamentos.length} lançamentos
                        </div>
                        {selectedAccountData.lancamentosIgnorados > 0 && (
                            <div className="summary-item" style={{color: '#f59e0b'}}>
                                <strong>⚠️ Ignorados:</strong> {selectedAccountData.lancamentosIgnorados} lançamento(s) não serão enviados
                            </div>
                        )}
                    </div>

                    {/* Action Bar do Relatório */}
                    <div className="action-bar">
                        {reportSelecionados.length > 0 && (
                            <div className="action-group">
                                <button
                                    className="btn btn-warning"
                                    onClick={async () => {
                                        try {
                                            // Alternar ignorar para todos os selecionados do relatório
                                            const selectedLancamentos = selectedAccountData.lancamentos.filter(l => reportSelecionados.includes(l.id));

                                            // Verificar se algum não está ignorado
                                            const hasNaoIgnorado = selectedLancamentos.some(l => !l.ignorarOmie);
                                            const novoEstado = hasNaoIgnorado; // true = ignorar, false = não ignorar

                                            const token = localStorage.getItem('token');
                                            const config = {
                                                headers: { Authorization: `Bearer ${token}` }
                                            };

                                            // Processar todos em paralelo
                                            await Promise.all(
                                                selectedLancamentos.map(lanc =>
                                                    axios.put(`/api/admin/lancamentos/${lanc.id}/ignorar`,
                                                        { ignorar: novoEstado },
                                                        config
                                                    )
                                                )
                                            );

                                            // Recarregar todos os dados
                                            await fetchData();

                                            // Limpar seleções e fechar relatório para ver resultado atualizado
                                            setReportSelecionados([]);
                                            setShowReport(false);

                                            alert(`${selectedLancamentos.length} lançamento(s) ${novoEstado ? 'marcado(s) para ignorar' : 'desmarcado(s)'} com sucesso!`);
                                        } catch (error) {
                                            console.error('Erro ao processar lançamentos:', error);
                                            alert('Erro ao processar lançamentos. Tente novamente.');
                                        }
                                    }}
                                >
                                    <span className="btn-icon">👁️</span>
                                    <span className="btn-text-mobile">Ignorar ({reportSelecionados.length})</span>
                                </button>
                                {reportSelecionados.length === 1 && (
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            const selectedId = reportSelecionados[0];
                                            const lancamento = selectedAccountData.lancamentos.find(l => l.id === selectedId);
                                            if (lancamento) {
                                                handleEditLancamento(lancamento);
                                            }
                                        }}
                                    >
                                        <span className="btn-icon">✏️</span>
                                        <span className="btn-text-mobile">Editar</span>
                                    </button>
                                )}
                                <button
                                    className="btn btn-danger"
                                    onClick={async () => {
                                        if (window.confirm(`Tem certeza que deseja excluir ${reportSelecionados.length} lançamentos?`)) {
                                            try {
                                                const token = localStorage.getItem('token');
                                                const config = {
                                                    headers: { Authorization: `Bearer ${token}` },
                                                    data: { ids: reportSelecionados }
                                                };
                                                await axios.delete('/api/admin/lancamentos', config);
                                                // Atualizar dados e fechar relatório
                                                setReportSelecionados([]);
                                                setShowReport(false);
                                                fetchData();
                                                alert('Lançamentos excluídos com sucesso!');
                                            } catch (error) {
                                                console.error('Erro ao excluir lançamentos:', error);
                                                alert('Erro ao excluir lançamentos. Tente novamente.');
                                            }
                                        }
                                    }}
                                >
                                    <span className="btn-icon">🗑️</span>
                                    <span className="btn-text-mobile">Excluir ({reportSelecionados.length})</span>
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="table-wrapper">
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th style={{width: '40px', minWidth: '40px'}}>
                                        <input
                                            type="checkbox"
                                            checked={selectedAccountData.lancamentos.length > 0 && selectedAccountData.lancamentos.every(item => reportSelecionados.includes(item.id))}
                                            onChange={() => handleSelectAllReport(selectedAccountData.lancamentos)}
                                            title="Selecionar todas"
                                        />
                                    </th>
                                    <th>Fornecedor</th>
                                    <th>Categoria</th>
                                    <th>Valor</th>
                                    <th>Data Compra</th>
                                    <th>Vencimento</th>
                                    <th>Observação</th>
                                </tr>
                            </thead>
                            <tbody>
                                 {selectedAccountData.lancamentos.map(item => (
                                    <tr key={item.id} className={item.ignorarOmie ? 'lancamento-ignorado' : ''}>
                                        <td style={{ textAlign: 'center', padding: '10px 8px' }}>
                                            <input
                                                type="checkbox"
                                                checked={reportSelecionados.includes(item.id)}
                                                onChange={() => handleSelectReportLancamento(item.id)}
                                            />
                                        </td>
                                        <td style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.fornecedor}</td>
                                        <td>{item.categoria}</td>
                                    {/* CORREÇÃO NA EXIBIÇÃO: Usar valorParcela se for parcelado */}
                                                            <td >{item.quantidadeParcelas > 0 ? formatCurrency(item.valorParcela) : formatCurrency(item.valorCompra)}</td>
                                        <td>{formatDateBR(item.dataCompra)}</td>
                                        <td>{formatDateBR(item.dataVencimento)}</td>
                                        <td >{item.observacao || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    
                    <div className="report-footer">
                        <button className="btn btn-cancel" onClick={() => setShowReport(false)}>
                            ← Voltar ao Dashboard
                        </button>
                    </div>
                </div>
            )}

            {/* Tabela de Lançamentos Sugeridos pela IA - CARD SEPARADO */}
            {!loading && lancamentosIA.length > 0 && !showFilters && !showReport && (
                <div className="table-card ia-card">
                    <div className="table-header ia-header">
                        <div className="ia-header-content">
                            <span className="ia-badge">IA</span>
                            <h2>Lançamentos Sugeridos por IA</h2>
                        </div>
                        <span className="table-count ia-count">{lancamentosIA.length} sugestões</span>
                    </div>

                    <div className="ia-description">
                        <p>Revise, edite ou valide os lançamentos sugeridos pela Inteligência Artificial antes de incluí-los nos registros oficiais.</p>
                    </div>

                    <div className="table-wrapper">
                        <table className="data-table ia-table">
                            <thead>
                                <tr>
                                    <th>Fornecedor</th>
                                    <th>Categoria</th>
                                    <th>Valor</th>
                                    <th>Data Compra</th>
                                    <th>Vencimento</th>
                                    <th>Observação</th>
                                    <th className="td-actions">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lancamentosIA.map(item => (
                                    <tr key={item.id} className="ia-row">
                                        <td style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.fornecedor}</td>
                                        <td>{item.categoria}</td>
                                        <td >{formatCurrency(item.valorCompra)}</td>
                                        <td>{formatDateBR(item.dataCompra)}</td>
                                        <td>{formatDateBR(item.dataVencimento)}</td>
                                        <td >{item.observacao || '-'}</td>
                                        <td className="td-actions">
                                            <div className="ia-action-buttons">
                                                <button
                                                    className="ia-btn ia-btn-validate"
                                                    onClick={() => handleValidarIA(item.id)}
                                                    title="Validar lançamento"
                                                >
                                                    ✓
                                                </button>
                                                <button
                                                    className="ia-btn ia-btn-edit"
                                                    onClick={() => handleEditIA(item)}
                                                    title="Editar lançamento"
                                                >
                                                    ✎
                                                </button>
                                                <button
                                                    className="ia-btn ia-btn-delete"
                                                    onClick={() => handleDeleteIA(item.id)}
                                                    title="Excluir lançamento"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </main>
    );
}

export default AdminDashboard;